const TONES = {
  violet: 'border-violet-100 bg-violet-50/80 text-violet-900',
  emerald: 'border-emerald-100 bg-emerald-50/80 text-emerald-900',
  amber: 'border-amber-100 bg-amber-50/80 text-amber-900',
  gray: 'border-gray-100 bg-gray-50 text-gray-800',
};

export default function PresencesKpiRow({ kpis }) {
  const cards = [
    { label: 'Membres actifs', value: kpis.actifs, tone: 'violet' },
    { label: 'Présents aujourd\'hui', value: kpis.presents, tone: 'emerald' },
    { label: 'Absents', value: kpis.absents, tone: 'gray' },
    { label: 'Indisponibles', value: kpis.indisponibles, tone: 'amber' },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className={`rounded-2xl border px-4 py-3 shadow-[0_1px_2px_rgba(15,23,42,0.04)] ${TONES[card.tone]}`}
        >
          <p className="text-[11px] font-semibold uppercase tracking-wide opacity-80">{card.label}</p>
          <p className="mt-1 text-2xl font-bold tabular-nums leading-none">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
